<template>
  <div class="form-edit-page">

    <!-- HEADER -->
    <div class="form-item">
      <h3>Logs de Acesso de Usuários</h3>

      <div class="row">
        <div class="col">
          <label>Empresa (IDEP)</label>
          <input v-model="filtro.idep" />
        </div>

        <div class="col">
          <label>Período Inicial</label>
          <input type="date" v-model="filtro.datainicial" />
        </div>

        <div class="col">
          <label>Período Final</label>
          <input type="date" v-model="filtro.datafinal" />
        </div>

        <div class="col btn-col">
          <button @click="lerDados">Consultar</button>
        </div>
      </div>
    </div>

    <!-- ALERTA -->
    <div v-if="msgAlerta" class="alert">
      {{ msgAlerta }}
    </div>

    <!-- LOADING -->
    <div v-if="isLoading" class="loading">
      Carregando dados...
    </div>

    <!-- TABELA -->
    <div class="form-item" v-if="!isLoading && logs.length">
      <table class="table">
        <thead>
          <tr>
            <th>Data/Hora</th>
            <th>Usuário</th>
            <th>App</th>
            <th>Versão</th>
            <th>IP</th>
            <th>SIM</th>
            <th>Estabelecimento</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="log in logs" :key="log.id">
            <td>{{ formatarDataHora(log.datacad) }}</td>
            <td>{{ log.nmusuario }}</td>
            <td>{{ log.appname }}</td>
            <td>{{ log.appver }}</td>
            <td>{{ log.iporigem }}</td>
            <td>{{ log.nmsim }}</td>
            <td>{{ log.nmestabelecimento }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- SEM DADOS -->
    <div v-if="!isLoading && logs.length === 0" class="empty">
      Nenhum registro encontrado.
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Api } from '@/funcoes/apiExport'

const logs = ref([])
const isLoading = ref(false)
const msgAlerta = ref(null)

const filtro = ref({
  idep: 9999,
  datainicial: '',
  datafinal: ''
})

// 🔹 função principal
async function lerDados() {
  try {
    msgAlerta.value = null
    isLoading.value = true

    const dados = {
      idep: filtro.value.idep,
      strparam1: 'SELECT UL.ID,    UL.IDUSUARIO,    UL.NMUSUARIO,    UL.IDEP,    UL.NMEP,    UL.APPNAME,    UL.APPVER,    UL.IPORIGEM,    UL.IDSIM, '
      + '    UL.NMSIM,    UL.IDESTABELECIMENTO,    UL.NMESTABELECIMENTO,    UL.DATACAD FROM USUARIOS_LOGIN UL '
      +'WHERE UL.IDEP = 9999   AND UL.DATACAD >= DATEADD(-EXTRACT(DAY FROM CURRENT_DATE) + 1 DAY TO CURRENT_DATE) '
      +'  AND UL.DATACAD < DATEADD(1 MONTH TO DATEADD(-EXTRACT(DAY FROM CURRENT_DATE) + 1 DAY TO CURRENT_DATE)) ORDER BY UL.DATACAD DESC'
    }

    logs.value = await Api.genericPost('/main/sql', dados)

  } catch (error) {
    msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`
  } finally {
    isLoading.value = false
  }
}

// 🔹 util
function formatarDataHora(data) {
  if (!data) return '-'
  const d = new Date(data)
  return d.toLocaleString('pt-BR')
}
</script>

<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  padding: 8px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

.alert {
  color: red;
  margin: 10px 0;
}

.loading {
  margin: 10px 0;
}

.empty {
  margin: 10px 0;
  font-style: italic;
}

.btn-col {
  display: flex;
  align-items: flex-end;
}
</style>